module.exports = __webpack_public_path__ + "img/shelf.c755e38e.png";